import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useStore } from 'context/store';
import Loading from 'components/Loading';

const PrivateRoute = props => {
    const { layout: Layout, component: Component, ...rest } = props;
    const [{ loading, user: { isLogin } }] = useStore();

    return loading ? <Loading /> : (
        <Route
            {...rest}
            render={matchProps => isLogin ?
                <Redirect
                    to={{
                        pathname: "/dashboard",
                        state: { from: props.location }
                    }}
                /> :
                <Layout>
                    <Component {...matchProps} />
                </Layout>
            }
        />
    );
};

PrivateRoute.propTypes = {
    component: PropTypes.any.isRequired,
    layout: PropTypes.any.isRequired,
    path: PropTypes.string
};

export default PrivateRoute;
